export function getErrorMessageIfValueExists(error: string | undefined, value: any) {
  if (!value) {
    return "";
  }

  return error;
}
